import { supabase } from '../../lib/supabase';
import type { Sound } from '../../types/database';

export async function updateSoundOrder(sounds: Sound[]): Promise<void> {
  try {
    // Create a transaction to update all sounds at once
    const updates = sounds.map((sound, index) => ({
      id: sound.id,
      order: index
    }));

    const { error } = await supabase.rpc('update_sound_order', {
      sound_updates: updates
    });

    if (error) throw error;
  } catch (error) {
    console.error('Error updating sound order:', error);
    throw error;
  }
}

export async function fetchSounds(bandId: string): Promise<Sound[]> {
  try {
    const { data, error } = await supabase
      .from('sounds')
      .select('*')
      .eq('band_id', bandId)
      .order('order', { ascending: true })
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching sounds:', error);
    throw error;
  }
}